import { videoEmbedUrl } from '../video';

/** Renders an inline player for YouTube / Vimeo links; returns null for other URLs. */
export function VideoEmbed({ url, title }: { url: string; title: string }) {
  const src = videoEmbedUrl(url);
  if (!src) return null;
  return (
    <div className="video">
      <iframe src={src} title={title} loading="lazy" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen" allowFullScreen referrerPolicy="strict-origin-when-cross-origin" />
    </div>
  );
}
